/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchAdminRemarkReqVo
 */
export interface BatchAdminRemarkReqVo {
    /**
     * 订单ID列表
     * @type {Array<number>}
     * @memberof BatchAdminRemarkReqVo
     */
    orderIds: Array<number>;
    /**
     * 管理员备注
     * @type {string}
     * @memberof BatchAdminRemarkReqVo
     */
    adminRemark: string;
}

/**
 * Check if a given object implements the BatchAdminRemarkReqVo interface.
 */
export function instanceOfBatchAdminRemarkReqVo(value: object): value is BatchAdminRemarkReqVo {
    if (!('orderIds' in value) || value['orderIds'] === undefined) return false;
    if (!('adminRemark' in value) || value['adminRemark'] === undefined) return false;
    return true;
}

export function BatchAdminRemarkReqVoFromJSON(json: any): BatchAdminRemarkReqVo {
    return BatchAdminRemarkReqVoFromJSONTyped(json, false);
}

export function BatchAdminRemarkReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchAdminRemarkReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderIds': json['orderIds'],
        'adminRemark': json['adminRemark'],
    };
}

export function BatchAdminRemarkReqVoToJSON(json: any): BatchAdminRemarkReqVo {
    return BatchAdminRemarkReqVoToJSONTyped(json, false);
}

export function BatchAdminRemarkReqVoToJSONTyped(value?: BatchAdminRemarkReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderIds': value['orderIds'],
        'adminRemark': value['adminRemark'],
    };
}

